<app-section-header
  [title]="'Update Newsletter'"
  [isBackBtnShown]="true"
  [preserveQueryParam]="true"
>
</app-section-header>

<mat-tab-group
  dynamicHeight
  mat-stretch-tabs="false"
  mat-align-tabs="center"
  animationDuration="0ms"
  [selectedIndex]="focusSite"
>
  <mat-tab
    [label]="regionNames[index]"
    *ngFor="let newsletterForm of newsletterForms; let index = index"
  >
    <ng-template matTabContent>
      <form [formGroup]="newsletterForm" class="max-w-3xl mx-auto my-5">
        <b class="m-0">Name:</b>
        <mat-form-field
          class="w-full"
          [floatLabel]="'never'"
          appearance="outline"
        >
          <input matInput formControlName="name" />
          <mat-error
            *ngIf="newsletterForm.controls.name.hasError('required')"
            class="pt-1 text-project-4300"
          >
            Please choose a name
          </mat-error>
        </mat-form-field>
        <b class="m-0">Description:</b>
        <mat-form-field
          class="w-full"
          [floatLabel]="'never'"
          appearance="outline"
        >
          <textarea
            matInput
            formControlName="description"
            matAutosizeMaxRows="5"
          ></textarea>
        </mat-form-field>
        <b class="m-0">Frequency:</b>
        <mat-radio-group
          formControlName="frequency"
          class="flex justify-between w-full py-4"
        >
          <mat-radio-button
            *ngFor="let frequency of availableFrequencies"
            [value]="frequency.key"
          >
            {{ frequency.name }}</mat-radio-button
          >
        </mat-radio-group>
        <mat-error
          *ngIf="
            newsletterForm.controls.frequency.hasError('required') &&
            newsletterForm.controls.frequency.touched
          "
          class="mb-4 text-project-4300"
        >
          Please choose a frequency
        </mat-error>
        <div [ngClass]="{ hidden: !lowerFrequencyAlternatives[index].length }">
          <b class="m-0">Lower Frequency Alternatives:</b>
          <mat-selection-list
            #lowerFrequency
            class="flex flex-wrap justify-between w-full"
          >
            <mat-list-option
              *ngFor="
                let lowerFreqAlt of lowerFrequencyAlternatives[index];
                let freqIndex = index
              "
              [value]="lowerFreqAlt"
              togglePosition="before"
              class="w-auto"
              [selected]="
                newsletterForm.controls.lowerFreqAlt.value?.indexOf(
                  lowerFreqAlt.id
                ) > -1
              "
            >
              {{ lowerFreqAlt.name }}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div
          *ngIf="
            newsletterForm.controls.lowerFreqAlt.value?.length ||
            lowerFrequency.selectedOptions.selected.length
          "
        >
          <b class="m-0">Default Lower Frequency Alternatives:</b>
          <mat-radio-group
            formControlName="lowerFreqAltDefault"
            class="flex flex-wrap justify-between w-full py-4"
          >
            <mat-radio-button
              *ngFor="
                let defLowerFreqAlt of lowerFrequency.selectedOptions?.selected;
                let defIndex = index
              "
              [value]="defLowerFreqAlt.value.id"
            >
              {{ defLowerFreqAlt.value.name }}</mat-radio-button
            >
          </mat-radio-group>
        </div>
        <b class="m-0">Other options:</b>
        <div class="flex py-2 mb-4">
          <mat-checkbox formControlName="special" class="w-full"
            >Is Special</mat-checkbox
          >
          <mat-checkbox formControlName="default" class="w-full"
            >Is Default</mat-checkbox
          >
          <mat-checkbox formControlName="displayOnce" class="w-full"
            >Displayed once</mat-checkbox
          >
        </div>
        <b class="m-0">Image url:</b>
        <mat-form-field
          class="w-full"
          [floatLabel]="'never'"
          appearance="outline"
        >
          <input matInput formControlName="imageUrl" class="py-2" />
        </mat-form-field>
        <div class="flex justify-between flex-1 mt-10">
          <button
            mat-stroked-button
            (click)="deleteNewsletter(index)"
            class="p-3 font-semibold text-project-1600"
          >
            Delete
          </button>
          <button
            mat-flat-button
            (click)="
              updateNewsletter(index, lowerFrequency.selectedOptions.selected)
            "
            class="w-1/4 py-3 font-semibold text-white bg-project-2100 disabled:bg-project-3200"
            [disabled]="submitted"
          >
            {{ submitted ? "Updating..." : "Update" }}
          </button>
        </div>
      </form>
    </ng-template>
  </mat-tab>
</mat-tab-group>
<ng-template #modalTemplate let-data>
  <h1 class="tracking-wide" mat-dialog-title>{{ data.title }}</h1>
  <div mat-dialog-content>
    <p class="tracking-wide">{{ data.message }}</p>
    <div
      class="pt-4 text-xs tracking-normal text-project-500"
      [ngClass]="{ hidden: !intranetTemplates?.length }"
    >
      This newsletter has the following Intranet templates :
      <span>{{ intranetTemplates?.join(", ") }}</span>
      <mat-checkbox class="w-full" #includeTemplates
        >Delete all Intranet templates too</mat-checkbox
      >
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="flex-1"></div>
    <button mat-button mat-dialog-close>
      {{ data.cancelLabel ?? "Cancel" }}
    </button>
    <button
      mat-flat-button
      color="primary"
      [mat-dialog-close]="{
        deleteNewsletter: true,
        includeTemplates: includeTemplates.checked
      }"
      cdkFocusInitial
    >
      {{ data.confirmLabel ?? "Yes" }}
    </button>
  </div>
</ng-template>
